import { render, staticRenderFns } from "./vehicleConfigDetails.vue?vue&type=template&id=1ddcaf58&scoped=true"
import script from "./vehicleConfigDetails.vue?vue&type=script&lang=js"
export * from "./vehicleConfigDetails.vue?vue&type=script&lang=js"
import style0 from "./vehicleConfigDetails.vue?vue&type=style&index=0&id=1ddcaf58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddcaf58",
  null
  
)

export default component.exports